import { Router } from "@frui.ts/screens";
import { attachAutomaticValidator } from "@frui.ts/validation";
import { Modules, newNavigationName } from "config";
import { computed } from "mobx";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import DistributorRepository from "repositories/distributorRepository";
import Distributor, { DistributorValidationRules } from "entities/distributor";
import DistributorType from "entities/distributorType";
import DistributorStatus from "entities/distributorStatus";
import OptionsService from "../../../../services/optionsService";
import CreateViewModel from "../../../createViewModel";

@Router.registerRoute({ name: Router.Self, route: newNavigationName })
export default class DistributorCreateViewModel extends CreateViewModel<Distributor> {
  readonly modelName = "distributor";

  constructor(
    protected repository: DistributorRepository,
    protected localizationService: LocalizationService,
    protected notificationService: NotificationService,
    protected eventBus: EventBus,
    private optionsService: OptionsService
  ) {
    super();
    this.navigationName = newNavigationName;
  }

  protected loadDetail() {
    const entity = new Distributor();
    attachAutomaticValidator(entity, DistributorValidationRules);
    return entity;
  }

  protected postData() {
    if (this.item.email == "") {
      const distributorCopy = Object.assign({}, this.item) as any;
      delete distributorCopy.email;
      return this.repository.create(distributorCopy);
    }
    return this.repository.create(this.item);
  }

  @computed
  get distributorTypeOptions() {
    return this.optionsService.internalEnumOptions(DistributorType);
  }

  @computed
  get distributorStatusOptions() {
    return this.optionsService.internalEnumOptions(DistributorStatus);
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.timeCharges, `distributorManagement.${code}`, size);
  }
}
